// --- Constants ---
export const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const FULL_NAME_PATTERN = /^(?!\s*$).+/;
export const FULL_NAME_MAX_LENGTH = 50;

// --- Patterns (match = valid) ---
// Used directly in Ant Design rules arrays AND negated by the test functions below.
// Single-line fields: reject C0 control chars and DEL
// eslint-disable-next-line no-control-regex
export const NO_CONTROL_CHARS = /^[^\x00-\x1F\x7F]*$/;
// Multi-line fields (TextArea): same but allow newlines (\n, \r)
// eslint-disable-next-line no-control-regex
export const NO_CONTROL_CHARS_ALLOW_NEWLINES = /^[^\x00-\x09\x0B\x0C\x0E-\x1F\x7F]*$/;
// Email fields: reject whitespace AND control chars
// eslint-disable-next-line no-control-regex
export const NO_WHITESPACE_OR_CONTROL_CHARS = /^[^\s\x00-\x1F\x7F]+$/;

// --- Test functions (return true when value is invalid) ---
// These negate the patterns above -- one regex per concept, no duplication.
export const hasControlChars = (value: string): boolean => !NO_CONTROL_CHARS.test(value);
export const hasWhitespaceOrControlChars = (value: string): boolean => !NO_WHITESPACE_OR_CONTROL_CHARS.test(value);
